import {put, call, takeLatest} from 'redux-saga/effects';
import { authenticatedAxios } from '../client';
import {
    GET_FAVORITES, getFavorites,
    POST_FAVORITE, postFavorite,
    POST_UNFAVORITE, postUnfavorite,
    SUBMIT_CREDIT_REQUEST_FORM, submitCreditRequestForm
} from "../actions/account";





function* handleSubmitCreditRequestForm({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        const response = yield call(authenticatedAxios.post, `${window.api_url}/site-secure/gift/missing-credit`, payload);
        yield put(submitCreditRequestForm({
            submitCreditRequestFormSuccess: true,
            refundedAmount: response.data.data.refunded_amount
        }, {'sent': true}));
    } catch (error) {
        yield put(submitCreditRequestForm(error, {}, true));
    }
}
export function* watchSubmitCreditRequestForm() {
    yield takeLatest(SUBMIT_CREDIT_REQUEST_FORM, handleSubmitCreditRequestForm);
}








function* handleGetFavorites({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let favorites = [];
    try {
        const response = yield call(authenticatedAxios.get, `${window.react_giftya_base_url}/secure/api/account/favorites`);
        favorites = response.data.favorites;
    } catch (error) {
        yield put(getFavorites(error, {}, true));
    }

    yield put(getFavorites({
        favorites
    }, {'sent': true}));
}
export function* watchGetFavorites() {
    yield takeLatest(GET_FAVORITES, handleGetFavorites);
}


function* handlePostFavorite({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.post, `${window.react_giftya_base_url}/secure/api/merchant/${payload.id}/favorite`);
        yield put(postFavorite({
            favorites: response.data.favorites
        }, {'sent': true}));
    } catch (error) {
        yield put(postFavorite(error, {}, true));
    }
}
export function* watchPostFavorite() {
    yield takeLatest(POST_FAVORITE, handlePostFavorite);
}



function* handlePostUnfavorite({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.post, `${window.react_giftya_base_url}/secure/api/merchant/${payload.id}/unfavorite`,);
        yield put(postUnfavorite({
            favorites: response.data.favorites,
        }, {'sent': true}));
    } catch (error) {
        yield put(postUnfavorite(error, {}, true));
    }
}
export function* watchPostUnfavorite() {
    yield takeLatest(POST_UNFAVORITE, handlePostUnfavorite);
}

